module.exports = __webpack_public_path__ + "static/media/undraw_time_management_30iu.56140b73.svg";